import script from "./ProductStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductStatus.vue?vue&type=script&setup=true&lang=js"

import "./ProductStatus.vue?vue&type=style&index=0&id=5ebca8aa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ebca8aa"]])

export default __exports__